"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidthResizerHotspot = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var useDashboardDrag_1 = require("../useDashboardDrag");
var model_1 = require("../../../model");
var sizing_1 = require("../../../_staging/layout/sizing");
var sizing_2 = require("../../layout/DefaultDashboardLayoutRenderer/utils/sizing");
var WidthResizerDragPreview_1 = require("../DragLayerPreview/WidthResizerDragPreview");
var LayoutResizeContext_1 = require("../LayoutResizeContext");
var WidthResizer_1 = require("./WidthResizer");
function WidthResizerHotspot(_a) {
    var item = _a.item, screen = _a.screen, getGridColumnWidth = _a.getGridColumnWidth, getGridColumnHeightInPx = _a.getGridColumnHeightInPx, getLayoutDimensions = _a.getLayoutDimensions;
    var dispatch = model_1.useDashboardDispatch();
    var insightsMap = model_1.useDashboardSelector(model_1.selectInsightsMap);
    var _b = LayoutResizeContext_1.useResizeHandlers(), resizeStart = _b.resizeStart, resizeEnd = _b.resizeEnd, getScrollCorrection = _b.getScrollCorrection;
    var widget = react_1.useMemo(function () { return item.widget(); }, [item]);
    var widgetIdentifier = widget.identifier;
    var _c = LayoutResizeContext_1.useResizeWidthItemStatus(widgetIdentifier), isWidthResizing = _c.isWidthResizing, isActive = _c.isActive;
    var _d = tslib_1.__read(react_1.useState(false), 2), isResizerVisible = _d[0], setResizerVisibility = _d[1];
    var onMouseEnter = function () { return setResizerVisibility(true); };
    var onMouseLeave = function () { return setResizerVisibility(false); };
    var sectionIndex = item.section().index();
    var itemIndex = item.index();
    var currentWidth = item.sizeForScreen(screen).gridWidth;
    var minLimit = sizing_1.getMinWidth(widget, insightsMap);
    var maxLimit = sizing_2.getDashboardLayoutItemMaxGridWidth(item, "xl");
    var _e = tslib_1.__read(useDashboardDrag_1.useDashboardDrag({
        dragItem: function () {
            var initialLayoutDimensions = getLayoutDimensions();
            return {
                type: "internal-width-resizer",
                sectionIndex: sectionIndex,
                itemIndex: itemIndex,
                gridColumnHeightInPx: getGridColumnHeightInPx(),
                gridColumnWidth: getGridColumnWidth(),
                initialLayoutDimensions: initialLayoutDimensions,
                currentWidth: currentWidth,
                minLimit: minLimit,
                maxLimit: maxLimit,
            };
        },
        dragEnd: function (dragItem, monitor) {
            var scrollCorrection = getScrollCorrection();
            var limitedSize = WidthResizerDragPreview_1.getSizeAndXCoords(dragItem, monitor.getInitialClientOffset().x, monitor.getDifferenceFromInitialOffset().x, scrollCorrection.x).limitedSize;
            dispatch(model_1.resizeWidth(sectionIndex, itemIndex, limitedSize));
            setResizerVisibility(false);
        },
    }, [widget, insightsMap, sectionIndex, itemIndex, currentWidth, minLimit, maxLimit]), 2), isDragging = _e[0].isDragging, dragRef = _e[1];
    react_1.useEffect(function () {
        if (isDragging) {
            resizeStart("width", [widgetIdentifier], getLayoutDimensions);
        }
        else {
            resizeEnd();
        }
    }, [isDragging]);
    var isThisResizing = isWidthResizing && isActive;
    var showHotspot = !isDragging || isWidthResizing || isResizerVisible;
    var showResizer = isResizerVisible || isThisResizing;
    var status = isDragging ? "muted" : "active";
    if (!showHotspot) {
        return null;
    }
    return (react_1.default.createElement("div", { className: "dash-width-resizer-container" },
        react_1.default.createElement("div", { className: "s-dash-width-resizer-hotspot dash-width-resizer-hotspot", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, ref: dragRef }, showResizer ? react_1.default.createElement(WidthResizer_1.WidthResizer, { status: status }) : null)));
}
exports.WidthResizerHotspot = WidthResizerHotspot;
//# sourceMappingURL=WidthResizerHotspot.js.map